import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.css']
})
export class RolesComponent implements OnInit {

  cid: any
  roles: any = [];
  rolesFilter: any = []
  form: any | FormGroup
  editForm: any | FormGroup
  privileges: any = []
  privileges1: any = []
  selectedPrivilegeIds: any = []
  singleRoleData: any = []
  singleRoleData1: any = []
  addButton = true;
  addSubmit = false;
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  first: any = 0
  tableSize: number = 10;
  userCred: any = []
  userPrivileges: any = []
  usersWithoutCustomers: any = []
  selectedRoleData: any = []
  roleId: any;
  isLoading: any = false
  editSubmit: any = false
  editButton: any = false
  userData: any = [];
  recordId: any = "";
  recordName: any = "";

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    console.log(this.userCred)
    // this.getAllRoles()
    // this.getRolesByCreatedBy(this.userCred.userId)
    this.form = this.fb.group({
      roleName: ['', [Validators.required]],
    })
    this.editForm = this.fb.group({
      roleName: ['']
    })
    this.getPrivileges()
    this.getAllPrivileges1()
    this.getUserById(this.userCred.userId)
  }

  getData() {
    if (this.userData[0].roleLevel && this.userData[0].roleLevel == 0) {
      this.getAllRoles()
    } else {
      this.getRolesByCreatedBy(this.userCred.userId)
    }
  }

  getUserById(userId: any) {
    this.generic_service.getUserById(userId).subscribe(
      (response: any) => {
        console.log(response)
        this.userData = []
        this.userData.push(response.response)
        this.getData()
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.pageNumber = event.page + 1;
    // this.getRolesByCreatedBy(this.userCred.userId)

  }

  getRolesByCreatedBy(userId: any) {
    this.isLoading = true

    this.generic_service.getRolesByCreatedBy(userId).subscribe(
      (res: any) => {
        console.log(res)
        this.roles = res.response;
        this.rolesFilter = res.response;
        this.totalRecords = res.response.length;
        this.isLoading = false
      }
    )
  }

  getAllRoles() {
    this.isLoading = true

    this.generic_service.getAllRoles().subscribe(
      (res: any) => {
        console.log(res)
        this.roles = res.response;
        this.rolesFilter = res.response;
        this.totalRecords = res.response.length;
        this.isLoading = false
      }
    )
  }


  addRole() {
    this.addSubmit = true;
    if (!this.form.valid) {
      console.log('invalid')
      this.toastr.error('role name required')

      return
    } else {
      let atleastOneRoleSelected = false
      for (var i = 0; i < this.privileges.length; i++) {
        if (this.privileges[i].isChecked) {
          atleastOneRoleSelected = true;
        }
      }
      if (!atleastOneRoleSelected) {
        this.toastr.error('select minimum one role')
        return
      }
    }
    this.addButton = false;
    console.log(this.privileges)
    let screenGroupList: any = []
    for (var i = 0; i < this.privileges.length; i++) {
      if (this.privileges[i].isChecked) {

        let arr: any = {
          "version": Number(this.privileges[i].version),
          "isActive": Boolean(this.privileges[i].isActive),
          "description": String(this.privileges[i].description),
          "seqNo": Number(this.privileges[i].seqNo),
          "groupName": String(this.privileges[i].groupName),
          "screenPrivilegeList": [],
          "cid": Number(this.privileges[i].cid),
        }

        for (var j = 0; j < this.privileges[i].screenPrivilegeList.length; j++) {
          if (this.privileges[i].screenPrivilegeList[j].isChecked) {
            let screenPrivilegeList = {
              "seqNo": Number(this.privileges[i].screenPrivilegeList[j].seqNo),
              "name": String(this.privileges[i].screenPrivilegeList[j].name),
              "add": this.privileges[i].screenPrivilegeList[j].add,
              "view": this.privileges[i].screenPrivilegeList[j].view,
              "modify": this.privileges[i].screenPrivilegeList[j].modify,
              "delete": this.privileges[i].screenPrivilegeList[j].delete,

              "verify": this.privileges[i].screenPrivilegeList[j].verify,
              "approve": this.privileges[i].screenPrivilegeList[j].approve,
              "issue": this.privileges[i].screenPrivilegeList[j].issue,
              "attach": this.privileges[i].screenPrivilegeList[j].attach,
              "remove": this.privileges[i].screenPrivilegeList[j].remove,
              "description": String(this.privileges[i].screenPrivilegeList[j].description),
              "screenPrivilegeScopeList": this.privileges[i].screenPrivilegeList[j].screenPrivilegeScopeList
            }
            arr.screenPrivilegeList.push(screenPrivilegeList)
          }
        }

        screenGroupList.push(arr)
      }

    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "roleName": String(this.form.get('roleName').value),
      "level": 0,
      "screenGroupList": screenGroupList,
      "cid": Number(this.cid)
    }
    console.log(body)
    this.generic_service.addRole(body).subscribe(
      (res: any) => {
        console.log(res)
        // this.getRolesByCreatedBy(this.userCred.userId)
        this.getData()

        this.toastr.success(res.message);
        this.cancelModel()
        this.form.reset()
        this.getPrivileges()
        this.getAllPrivileges1()
        this.privileges1 = []
        this.privileges = []
        this.addButton = true;
        this.addSubmit = false;
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
        this.addButton = true
      }
    )
  }

  addRoleClose() {
    this.form.reset()
    this.getPrivileges()
    this.getAllPrivileges1()
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton4")?.click()
    document.getElementById("closeModalButton1")?.click()


    this.recordId = "";
    this.recordName = "";
  }

  getAllPrivileges1() {

    this.generic_service.getRoleById(this.userCred.roleId[1]).subscribe(
      (response: any) => {

        console.log(response)
        this.privileges1 = []
        this.privileges1 = response.response.screenGroupList;
        for (let i = 0; this.privileges1.length > i; i++) {
          this.privileges1[i].isChecked = false;
          for (let j = 0; this.privileges1[i].screenPrivilegeList.length > j; j++) {
            this.privileges1[i].screenPrivilegeList[j].isChecked = false;

            this.privileges1[i].screenPrivilegeList[j].isView = this.privileges1[i].screenPrivilegeList[j].view || false;
            this.privileges1[i].screenPrivilegeList[j].isAdd = this.privileges1[i].screenPrivilegeList[j].add || false;
            this.privileges1[i].screenPrivilegeList[j].isDelete = this.privileges1[i].screenPrivilegeList[j].delete || false;
            this.privileges1[i].screenPrivilegeList[j].isModify = this.privileges1[i].screenPrivilegeList[j].modify || false;


            this.privileges1[i].screenPrivilegeList[j].isVerify = this.privileges1[i].screenPrivilegeList[j].verify || false;
            this.privileges1[i].screenPrivilegeList[j].isApprove = this.privileges1[i].screenPrivilegeList[j].approve || false;
            this.privileges1[i].screenPrivilegeList[j].isIssue = this.privileges1[i].screenPrivilegeList[j].issue || false;
            this.privileges1[i].screenPrivilegeList[j].isAttach = this.privileges1[i].screenPrivilegeList[j].attach || false;
            this.privileges1[i].screenPrivilegeList[j].isRemove = this.privileges1[i].screenPrivilegeList[j].remove || false;


          }
        }
        console.log(this.privileges1)
      }
    )

  }

  getPrivileges() {
    this.generic_service.getRoleById(this.userCred.roleId[1]).subscribe(
      (response: any) => {
        console.log(response)
        this.privileges = []
        this.privileges = response.response.screenGroupList;
        for (let i = 0; this.privileges.length > i; i++) {
          this.privileges[i].isChecked = false;
          for (let j = 0; this.privileges[i].screenPrivilegeList.length > j; j++) {
            this.privileges[i].screenPrivilegeList[j].isChecked = false;
            this.privileges[i].screenPrivilegeList[j].isView = this.privileges[i].screenPrivilegeList[j].view || false;
            this.privileges[i].screenPrivilegeList[j].isAdd = this.privileges[i].screenPrivilegeList[j].add || false;
            this.privileges[i].screenPrivilegeList[j].isDelete = this.privileges[i].screenPrivilegeList[j].delete || false;
            this.privileges[i].screenPrivilegeList[j].isModify = this.privileges[i].screenPrivilegeList[j].modify || false;

            this.privileges[i].screenPrivilegeList[j].isVerify = this.privileges[i].screenPrivilegeList[j].verify || false;
            this.privileges[i].screenPrivilegeList[j].isApprove = this.privileges[i].screenPrivilegeList[j].approve || false;
            this.privileges[i].screenPrivilegeList[j].isIssue = this.privileges[i].screenPrivilegeList[j].issue || false;
            this.privileges[i].screenPrivilegeList[j].isAttach = this.privileges[i].screenPrivilegeList[j].attach || false;
            this.privileges[i].screenPrivilegeList[j].isRemove = this.privileges[i].screenPrivilegeList[j].remove || false;
          }
        }
        console.log(this.privileges)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllPrivileges() {
    this.generic_service.getAllPrivileges().subscribe(
      (response: any) => {
        this.privileges = response.response;
        for (let i = 0; this.privileges.length > i; i++) {
          this.privileges[i].isChecked = false;
          for (let j = 0; this.privileges[i].screenPrivilegeList.length > j; j++) {
            this.privileges[i].screenPrivilegeList[j].isChecked = false;
          }
        }
      }
    )
  }

  isChecked(event: any, i: any) {
    console.log(event)
    console.log(i)
    this.privileges[i].isChecked = event.target.checked;

    if (this.privileges[i].isChecked == true) {
      for (var j = 0; j < this.privileges[i].screenPrivilegeList.length; j++) {
        this.privileges[i].screenPrivilegeList[j].isChecked = true;
        this.privileges[i].screenPrivilegeList[j].view = true;
        if (this.privileges[i].screenPrivilegeList[j].isAdd) {
          this.privileges[i].screenPrivilegeList[j].add = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isModify) {
          this.privileges[i].screenPrivilegeList[j].modify = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isDelete) {
          this.privileges[i].screenPrivilegeList[j].delete = true;
        }

        if (this.privileges[i].screenPrivilegeList[j].isVerify) {
          this.privileges[i].screenPrivilegeList[j].verify = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isApprove) {
          this.privileges[i].screenPrivilegeList[j].approve = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isIssue) {
          this.privileges[i].screenPrivilegeList[j].issue = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isAttach) {
          this.privileges[i].screenPrivilegeList[j].attach = true;
        }
        if (this.privileges[i].screenPrivilegeList[j].isRemove) {
          this.privileges[i].screenPrivilegeList[j].remove = true;
        }


      }
    } else {
      for (var j = 0; j < this.privileges[i].screenPrivilegeList.length; j++) {
        this.privileges[i].screenPrivilegeList[j].isChecked = false;
        this.privileges[i].screenPrivilegeList[j].view = false;
        this.privileges[i].screenPrivilegeList[j].add = false;
        this.privileges[i].screenPrivilegeList[j].delete = false;
        this.privileges[i].screenPrivilegeList[j].modify = false;

        this.privileges[i].screenPrivilegeList[j].verify = false;
        this.privileges[i].screenPrivilegeList[j].approve = false;
        this.privileges[i].screenPrivilegeList[j].issue = false;
        this.privileges[i].screenPrivilegeList[j].attach = false;
        this.privileges[i].screenPrivilegeList[j].remove = false;
      }
    }
    console.log(this.privileges[i])
  }

  screenCheck(event: any, i: any, j: any) {
    this.privileges[i].screenPrivilegeList[j].isChecked = event.target.checked;
    if (event.target.checked == true) {
      this.privileges[i].screenPrivilegeList[j].view = true;
      if (this.privileges[i].screenPrivilegeList[j].isAdd) {
        this.privileges[i].screenPrivilegeList[j].add = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isModify) {
        this.privileges[i].screenPrivilegeList[j].modify = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isDelete) {
        this.privileges[i].screenPrivilegeList[j].delete = true;
      }

      if (this.privileges[i].screenPrivilegeList[j].isVerify) {
        this.privileges[i].screenPrivilegeList[j].verify = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isApprove) {
        this.privileges[i].screenPrivilegeList[j].approve = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isIssue) {
        this.privileges[i].screenPrivilegeList[j].issue = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isAttach) {
        this.privileges[i].screenPrivilegeList[j].attach = true;
      }
      if (this.privileges[i].screenPrivilegeList[j].isRemove) {
        this.privileges[i].screenPrivilegeList[j].remove = true;
      }
    } else {
      this.privileges[i].screenPrivilegeList[j].view = false;
      this.privileges[i].screenPrivilegeList[j].add = false;
      this.privileges[i].screenPrivilegeList[j].modify = false;
      this.privileges[i].screenPrivilegeList[j].delete = false;

      this.privileges[i].screenPrivilegeList[j].verify = false;
      this.privileges[i].screenPrivilegeList[j].approve = false;
      this.privileges[i].screenPrivilegeList[j].issue = false;
      this.privileges[i].screenPrivilegeList[j].attach = false;
      this.privileges[i].screenPrivilegeList[j].remove = false;
    }
    console.log(this.privileges[i].screenPrivilegeList[j])
    let privilege = false;
    if (event.target.checked == false) {
      for (var k = 0; k < this.privileges[i].screenPrivilegeList.length; k++) {
        if (this.privileges[i].screenPrivilegeList[k].isChecked == true) {
          privilege = true;
        }
      }
      if (privilege == false) {
        this.privileges[i].isChecked = false;
      }
    } else {
      this.privileges[i].isChecked = true;
    }
  }

  getRoleById(roleId: any) {
    this.generic_service.getRoleById(roleId).subscribe(
      (response: any) => {
        this.singleRoleData = []
        this.singleRoleData.push(response.response)
        this.userPrivileges = []
        this.userPrivileges.push(response.response)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  privilegeAdjust(index: any, position: any) {
    var arr = this.userPrivileges[0].screenGroupList;
    if (position == 'up') {
      var currentPosition = Number(index);
      var pos = Number(index) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(index);
      var pos = Number(index) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  screenPrivilegeListAdjust(privilegeIndex: any, screenIndex: any, position: any) {
    var arr = this.userPrivileges[0].screenGroupList[privilegeIndex].screenPrivilegeList;
    if (position == 'up') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  selectRole(roleId: any) {
    this.roleId = roleId
  }

  selectDelete(id: any, record: any) {
    this.roleId = id;
    this.recordId = record.roleId;
    this.recordName = record.roleName;
  }


  deleteRole() {
    this.generic_service.deleteRole(this.roleId).subscribe(
      (response: any) => {
        // this.getRolesByCreatedBy(this.userCred.userId)
        this.getData()

        this.toastr.success(response.message),
          this.cancelModel()
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);

      }
    )
  }











  isChecked1(event: any, i: any) {
    console.log(event)
    console.log(i)
    this.privileges1[i].isChecked = event.target.checked;

    if (this.privileges1[i].isChecked == true) {
      for (var j = 0; j < this.privileges1[i].screenPrivilegeList.length; j++) {
        this.privileges1[i].screenPrivilegeList[j].isChecked = true;
        this.privileges1[i].screenPrivilegeList[j].view = true;
        this.privileges1[i].screenPrivilegeList[j].add = true;
        this.privileges1[i].screenPrivilegeList[j].delete = true;
        this.privileges1[i].screenPrivilegeList[j].modify = true;
      }
    } else {
      for (var j = 0; j < this.privileges1[i].screenPrivilegeList.length; j++) {
        this.privileges1[i].screenPrivilegeList[j].isChecked = false;
        this.privileges1[i].screenPrivilegeList[j].view = false;
        this.privileges1[i].screenPrivilegeList[j].add = false;
        this.privileges1[i].screenPrivilegeList[j].delete = false;
        this.privileges1[i].screenPrivilegeList[j].modify = false;
      }
    }
    console.log(this.privileges[i])
  }

  screenCheck1(event: any, i: any, j: any) {
    this.privileges1[i].screenPrivilegeList[j].isChecked = event.target.checked;
    if (event.target.checked == true) {
      this.privileges1[i].screenPrivilegeList[j].view = true;
      this.privileges1[i].screenPrivilegeList[j].add = true;
      this.privileges1[i].screenPrivilegeList[j].modify = true;
      this.privileges1[i].screenPrivilegeList[j].delete = true;

      this.privileges1[i].screenPrivilegeList[j].verify = true;
      this.privileges1[i].screenPrivilegeList[j].approve = true;
      this.privileges1[i].screenPrivilegeList[j].issue = true;
      this.privileges1[i].screenPrivilegeList[j].attach = true;
      this.privileges1[i].screenPrivilegeList[j].remove = true;

    } else {
      this.privileges1[i].screenPrivilegeList[j].view = false;
      this.privileges1[i].screenPrivilegeList[j].add = false;
      this.privileges1[i].screenPrivilegeList[j].modify = false;
      this.privileges1[i].screenPrivilegeList[j].delete = false;

      this.privileges1[i].screenPrivilegeList[j].verify = false;
      this.privileges1[i].screenPrivilegeList[j].approve = false;
      this.privileges1[i].screenPrivilegeList[j].issue = false;
      this.privileges1[i].screenPrivilegeList[j].attach = false;
      this.privileges1[i].screenPrivilegeList[j].remove = false;
    }
    console.log(this.privileges1[i].screenPrivilegeList[j])
    let privilege = false;
    if (event.target.checked == false) {
      for (var k = 0; k < this.privileges1[i].screenPrivilegeList.length; k++) {
        if (this.privileges1[i].screenPrivilegeList[k].isChecked == true) {
          privilege = true;
        }
      }
      if (privilege == false) {
        this.privileges1[i].isChecked = false;
      }
    } else {
      this.privileges1[i].isChecked = true;
    }
  }


  getRoleById1(id: any) {
    this.roleId = id
    // for(let i=0;this.privileges1.length > i; i++){
    //   this.privileges1[i].isChecked = false;
    //   for(let j=0;this.privileges1[i].screenPrivilegeList.length > j; j++){
    //     this.privileges1[i].screenPrivilegeList[j].isChecked = false;
    //   }
    // }
    console.log(this.privileges1)
    this.generic_service.getRoleById(id).subscribe(
      (response: any) => {
        console.log(response)
        this.singleRoleData1 = response.response
        this.editForm.patchValue({
          roleName: response.response.roleName
        });
        for (var i = 0; i < response.response.screenGroupList.length; i++) {
          for (var j = 0; j < this.privileges1.length; j++) {
            if (this.privileges1[j].groupName == response.response.screenGroupList[i].groupName) {

              this.privileges1[j].isChecked = true;
              for (var k = 0; k < response.response.screenGroupList[i].screenPrivilegeList.length; k++) {

                for (var l = 0; l < this.privileges1[j].screenPrivilegeList.length; l++) {

                  if (response.response.screenGroupList[i].screenPrivilegeList[k].description == this.privileges1[j].screenPrivilegeList[l].description) {
                    this.privileges1[j].screenPrivilegeList[l].isChecked = true;

                    this.privileges1[j].screenPrivilegeList[l].add = response.response.screenGroupList[i].screenPrivilegeList[k].add;
                    this.privileges1[j].screenPrivilegeList[l].delete = response.response.screenGroupList[i].screenPrivilegeList[k].delete;
                    this.privileges1[j].screenPrivilegeList[l].view = response.response.screenGroupList[i].screenPrivilegeList[k].view;
                    this.privileges1[j].screenPrivilegeList[l].modify = response.response.screenGroupList[i].screenPrivilegeList[k].modify;


                    this.privileges1[j].screenPrivilegeList[l].verify = response.response.screenGroupList[i].screenPrivilegeList[k].verify;
                    this.privileges1[j].screenPrivilegeList[l].approve = response.response.screenGroupList[i].screenPrivilegeList[k].approve;
                    this.privileges1[j].screenPrivilegeList[l].issue = response.response.screenGroupList[i].screenPrivilegeList[k].issue;
                    this.privileges1[j].screenPrivilegeList[l].attach = response.response.screenGroupList[i].screenPrivilegeList[k].attach;
                    this.privileges1[j].screenPrivilegeList[l].remove = response.response.screenGroupList[i].screenPrivilegeList[k].remove;



                  }
                }
              }
            }
          }
        }
        console.log(this.privileges1)
      },
      (error) => {
        console.log(error)
      }
    )
  }


  updateRole() {
    this.editSubmit = true;
    if (!this.editForm.valid) {
      console.log('invalid')
      this.toastr.error('role name required')

      return
    } else {
      let atleastOneRoleSelected = false
      for (var i = 0; i < this.privileges1.length; i++) {
        if (this.privileges1[i].isChecked) {
          atleastOneRoleSelected = true;
        }
      }
      if (!atleastOneRoleSelected) {
        this.toastr.error('select minimum one role')
        return
      }
    }
    this.editButton = false;
    console.log(this.privileges)
    let screenGroupList: any = []
    for (var i = 0; i < this.privileges1.length; i++) {
      if (this.privileges1[i].isChecked) {

        let arr: any = {
          "version": Number(this.privileges1[i].version),
          "isActive": Boolean(this.privileges1[i].isActive),
          "description": String(this.privileges1[i].description),
          "seqNo": Number(this.privileges1[i].seqNo),
          "groupName": String(this.privileges1[i].groupName),
          "screenPrivilegeList": [],
          "cid": Number(this.privileges1[i].cid),
        }

        for (var j = 0; j < this.privileges1[i].screenPrivilegeList.length; j++) {
          if (this.privileges1[i].screenPrivilegeList[j].isChecked) {
            let screenPrivilegeList = {
              "add": this.privileges1[i].screenPrivilegeList[j].add,
              "view": this.privileges1[i].screenPrivilegeList[j].view,
              "modify": this.privileges1[i].screenPrivilegeList[j].modify,
              "delete": this.privileges1[i].screenPrivilegeList[j].delete,


              "verify": this.privileges1[i].screenPrivilegeList[j].verify,
              "approve": this.privileges1[i].screenPrivilegeList[j].approve,
              "issue": this.privileges1[i].screenPrivilegeList[j].issue,
              "attach": this.privileges1[i].screenPrivilegeList[j].attach,
              "remove": this.privileges1[i].screenPrivilegeList[j].remove,
              "seqNo": Number(this.privileges1[i].screenPrivilegeList[j].seqNo),
              "name": String(this.privileges1[i].screenPrivilegeList[j].name),
              "description": String(this.privileges1[i].screenPrivilegeList[j].description),
              "screenPrivilegeScopeList": this.privileges1[i].screenPrivilegeList[j].screenPrivilegeScopeList
            }
            arr.screenPrivilegeList.push(screenPrivilegeList)
          }
        }

        screenGroupList.push(arr)
      }

    }

    let body = {
      "version": Number(this.singleRoleData1.version),
      "isActive": Boolean(this.singleRoleData1.isActive),
      "description": String(this.singleRoleData1.description),
      "roleId": Number(this.singleRoleData1.roleId),
      "roleName": String(this.editForm.get('roleName').value),
      "screenGroupList": screenGroupList,
      "cid": Number(this.singleRoleData1.cid),
    }
    console.log(body)
    this.generic_service.updateRole(body).subscribe(
      (res: any) => {
        console.log(res)
        // this.getRolesByCreatedBy(this.userCred.userId)
        this.getData()

        this.toastr.success(res.message);
        this.cancelModel()
        this.editForm.reset()
        this.getAllPrivileges()
        this.getAllPrivileges1()
        this.privileges1 = []
        this.privileges = []
        this.editButton = true;
        this.editSubmit = false;
      },
      (error: any) => {
        console.log(error)
        this.editButton = true
      }
    )
  }

  searchKey: any = ""

  getRolesByWildSearch(pageNumber: any, recordsPerPage: any) {
    if (this.searchKey != "") {
      this.isLoading = true

      this.generic_service.getRolesByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          this.roles = response.response.rolesList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getRolesByCreatedBy(this.userCred.userId)

    }
  }

  refreshAll() {
    this.pageNumber = 1
    this.first = 0
    this.searchKey = ""
    // this.getRolesByCreatedBy(this.userCred.userId)
    this.getData()

  }

  searchByRoleName(): void {
    const searchValue = this.searchKey.trim().toLowerCase();

    if (searchValue) {
      this.roles = this.rolesFilter.filter((role: any) =>
        role.roleName?.toLowerCase().includes(searchValue)
      );

      this.totalRecords = this.roles.length;
      this.pageNumber = 1
      this.first = 0
    } else {
      // create a new array reference
      this.roles = [...this.rolesFilter];
      this.totalRecords = this.roles.length;
      this.pageNumber = 1
      this.first = 0

    }
  }


}